<template>
    <v-dialog v-model="dialog" max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit user</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New user parameters
            </v-card-title>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="primary" label="user e-mail" 
                                    v-model="email" 
                                    type="text"
                                    :rules="[rules.required]" 
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-select dense color="primary" 
                                    label="user role" 
                                    v-model="role" 
                                    :items="roles"
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" 
                    :disabled="!valid || Boolean(error)"
                    @click="updateUser">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'UpdateUser',
    props: ['user'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            roles: ['TEAM', 'PROFESSOR', 'ADMIN'],
            rules: {
                required: v => !!v || 'this field is required',
            },
            //props
            role: this.user.role,
            email: this.user.email,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        }
    },
    methods: {

        onceMore() {
            this.error = '';
        },
        async updateUser() {

            if (this.$refs.form.validate()) {

                if (this.email == this.user.email && this.role == this.user.role) {
                    this.error = 'No parameters of the user have been changed';
                    return
                }
                const user = {
                    id: this.user.id,
                    email: this.email,
                    role: this.role
                }
                try {
                    //add game
                    await this.$store.dispatch('updateUser', user)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                } 
            }
        },
        closeDialog() {
            //reset
            this.dialog = false
            this.error = ''
            this.role = this.user.role;
            this.email = this.user.email;
        }
    }
}
</script>
